import React, { useState } from "react";
import "./ContactPopup.css";
import { HostApi } from "../configuration";
import axios from "axios";
const ContactPopup = ({ isOpen, onClose }) => {

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const handleSubmit = async () => {
      if (!name || !email || !message || !phone) {
        setMsg("All fields are required");
        return;
      }
      if (phone.length !== 10) {
        setMsg("Enter a valid 10-digit number");
        return;
      }
      try {
        setLoading(true);
        setMsg("");
  
      console.log(`${HostApi()}/api/Advisor/servicerequest`);
        const res = await axios.post(
          `${HostApi()}/api/Advisor/servicerequest`,
          {
            name: name,
            email: email,
            phone: phone,
            message: message
          }
        );
  
        if (res.data) {
          setMsg("Message sent successfully ✅");
  
          // clear fields
          setName("");
          setEmail("");
          setMessage("");
        }
        setPhone("");
  
      } catch (err) {
        setMsg("Server error ❌");
      } finally {
        setLoading(false);
      }
    };

  return (
    <>
      {/* OVERLAY */}
      <div
        className={`popup-overlay ${isOpen ? "show-overlay" : ""}`}
        onClick={onClose}
      ></div>

      {/* SIDEBAR FORM */}
      <div className={`contact-popup ${isOpen ? "show-popup" : ""}`}>

        {/* HEADER */}
        <div className="popup-header">
          <h2>Contact Us</h2>

          <button onClick={onClose}>
            ✕
          </button>
        </div>

        {/* FORM */}
        <div className="popup-form">

          <h3>Get Expert Assistance</h3>

          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <input
            type="number"
            placeholder="Mobile No."
            value={phone}
            onChange={(e) => setPhone(e.target.value.slice(0, 10))}
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <textarea
            placeholder="Requirements..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>

          <button onClick={handleSubmit} disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>

          {msg && (
            <p className="popup-message">
              {msg}
            </p>
          )}

        </div>
      </div>
    </>
  );
};

export default ContactPopup;